var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { createStyles, withStyles } from '../styles/withStyles';
import NoActivities from './internal/NoActivities';
import NoEnrolled from './internal/NoEnrolled';
import NoRequest from './internal/NoRequest';
import NoWaitlist from './internal/NoWaitlist';
const styles = (theme) => createStyles({
    primary: {
        color: theme.palette.primary.main
    },
    root: {},
    secondary: {
        color: theme.palette.secondary.main
    }
});
const ILLUSTRATIONS = {
    'no-activities': NoActivities,
    'no-enrolled': NoEnrolled,
    'no-request': NoRequest,
    'no-waitlist': NoWaitlist
};
const InternalIllustration = (props, ref) => {
    const { SvgProps, className, classes, color, name } = props, rest = __rest(props, ["SvgProps", "className", "classes", "color", "name"]);
    const InternalIllustrationComponent = ILLUSTRATIONS[name];
    return (React.createElement("span", Object.assign({ className: classnames(classes.root, {
            [classes.primary]: color === 'primary',
            [classes.secondary]: color === 'secondary'
        }, className), ref: ref }, rest),
        React.createElement(InternalIllustrationComponent, Object.assign({}, SvgProps))));
};
const InternalIllustrationFRC = forwardRef(InternalIllustration);
InternalIllustrationFRC.displayName = 'InternalIllustrationFRC';
InternalIllustrationFRC.defaultProps = {
    color: 'secondary'
};
export default withStyles(styles, { name: 'InternalIllustrationWS' })(InternalIllustrationFRC);
